import React, { useMemo } from 'react';
import { gql } from 'urql';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { useAuthenticatedQuery } from '../../../client/hooks';
import {
    HighSchoolMyEventsDocument,
    HighSchoolMyEventsQuery,
    HighSchoolMyEventsQueryVariables,
} from '../../../generated/spin-graphql';
import { PlayerMyEventsSkeleton } from './PlayerMyEventsSkeleton';
import { HighSchoolTeamEventRegistrationsCard } from './HighSchoolTeamEventRegistrationsCard';
import { ExploreEventsCard } from './ExploreEventsCard';

type Props = {
    user: AppStateUser;
};

gql`
    query HighSchoolMyEvents($highSchoolId: uuid!) {
        espin_team {
            ...HighSchoolTeamEventRegistrationsCard
        }
    }
`;

export const HighSchoolMyEvents: React.FC<Props> = ({ user }) => {
    const { isReady, data } = useAuthenticatedQuery<HighSchoolMyEventsQuery, HighSchoolMyEventsQueryVariables>({
        query: HighSchoolMyEventsDocument,
        variables: {
            highSchoolId: user.high_school_profile?.high_school?.id,
        },
        pause: !!!user,
    });

    const filteredTeams = useMemo(() => {
        return data && data.espin_team ? data.espin_team.filter((team) => team.event_registrations.length > 0) : [];
    }, [data]);

    if (!isReady) {
        return <PlayerMyEventsSkeleton />;
    }

    return (
        <div className="my-events-high-school">
            <div className="content">
                {filteredTeams.length > 0 &&
                    filteredTeams.map((team, index) => (
                        <HighSchoolTeamEventRegistrationsCard key={`team${index}`} team={team} />
                    ))}
                <ExploreEventsCard />
            </div>
        </div>
    );
};
